module.exports = __webpack_public_path__ + "img/FailPro.ca7d41cb.png";